var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forbidden-div"},[_c('span',{staticClass:"forbidden-span"},[_vm._v("Use Cognizant user to access the app.")]),_c('button',{staticClass:"logout-button",on:{"click":_vm.logout}},[_vm._v("Sign Out")])])}
var staticRenderFns = []

export { render, staticRenderFns }